import { useContext, useState } from 'react';

import { LanguageContext } from '@shared/contexts/LanguageContext';
import { lang } from '@shared/services';

import AboutSection from './components/AboutSection';
import ExplainerSection from './components/ExplainerSection';
import Footer from './components/Footer';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TermsModal from './components/TermsModal';
import WhySection from './components/WhySection';

import './styles.scss';

function MainPage() {
    const { language: selectedLanguage, setLanguage } = useContext(LanguageContext);
    const [isTermsModalOpen, setTermsModalOpen] = useState(false);
    const language = selectedLanguage === 'ru' || selectedLanguage === 'en' ? selectedLanguage : 'en';
    const t = (key) => lang.t(`version2.${key}`);
    const openTerms = () => setTermsModalOpen(true);
    const closeTerms = () => setTermsModalOpen(false);

    return (
        <div className="site-shell">
            <Header
                language={language}
                onChangeLanguage={setLanguage}
                onOpenTerms={openTerms}
                t={t}
            />
            <main id="top">
                <HeroSection onOpenTerms={openTerms} t={t} />
                <ExplainerSection t={t} />
                <AboutSection t={t} />
                <WhySection t={t} />
            </main>
            <Footer onOpenTerms={openTerms} t={t} />
            {isTermsModalOpen && <TermsModal onClose={closeTerms} t={t} />}
        </div>
    );
}

export default MainPage;
